export const REFRESH_TOKEN_COOKIE_NAME = process.env.REFRESH_AUTH_COOKIE_NAME ?? 'refreshToken';

// Persist the refresh-token cookie for the token's full server-side lifetime
// (api `security.jwt.refresh.token.expire-length` = 30 days). Without a maxAge
// it is a session cookie, which iOS clears when it evicts a backgrounded tab —
// forcing repeated re-login on mobile (PB-2767).
export const REFRESH_TOKEN_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

/**
 * Marker cookie set while a back-office "Login As User" session is open. Carries
 * no credential — its only job is getting the iframe past the `proxy.ts` gate,
 * which reads cookies but cannot read the sessionStorage holding the real token.
 */
export const IMPERSONATION_COOKIE_NAME = 'pb-impersonation';

export const LOGIN_PATH = '/login';
export const APP_PATH = '/myaccount';
const PROTECTED_ROUTE_PREFIXES = ['/myaccount'];

export const isProtectedRoute = (pathname: string) =>
  PROTECTED_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));

/** Auth-flow routes (login, OAuth callback) — these never require an existing session. */
export const isAuthFlowRoute = (pathname: string) =>
  pathname.startsWith(LOGIN_PATH) || pathname.startsWith('/auth');

/**
 * Whether a route requires an authenticated session. True for protected routes,
 * or — when the tenant disables guest browsing — for everything except the
 * auth-flow routes. Single source of truth shared by ClientRouteGuardProvider
 * (which redirects) and AppBootGate (which shows the boot loader during that
 * redirect), so the rule can't drift between them. (PB-3288)
 */
export const computeRequiresAuth = (pathname: string, disableGuestBrowsing: boolean) =>
  isProtectedRoute(pathname) || (disableGuestBrowsing && !isAuthFlowRoute(pathname));
